export default {
    hinterBox: [
                '<span class="uwr-input-hint">',
                        '<span class="uwr-input-hint-hidden"></span>',
                        '<span class="uwr-input-hint-visible"></span>',
                '</span>'
        ].join(''),
    visibleField: '<input />'
};



//////////////////
// WEBPACK FOOTER
// ./widgets/Input/features/js/formatterView.js
// module id = 90
// module chunks = main